/* ─────────────────────────────────────────────────────────────────────────────
   meta-co.js — LA BARRA DE META, NATIVA (dictado del dueño 08-sep, notas §12 y §13).
   Reemplaza a «Essential Free Shipping» ($29,99/30d). El marcado lo pinta
   snippets/meta-co.liquid; la piel, skin-tienda-co.css.

   ═══════════════════════════════════════════════════════════════════════════
   LAS DOS METAS SON DISTINTAS, Y ESTÁ MEDIDO
   ═══════════════════════════════════════════════════════════════════════════
   Medido el 09-sep con carritos reales contra soybuda.com.co, preguntándole a Shopify
   sus tarifas de envío (`/cart/shipping_rates.json`):

     subtotal $141.900 → el -30% «A&M❤️» deja el total en $99.330 → ENVIO $17.700
     subtotal $189.200 → el -30% deja el total en $132.440        → ENVIO GRATIS $0

   La condición de la tarifa («TOTAL_PRICE ≥ $129.000») mira el total DESPUÉS de
   descuentos, así que el propio -30% empuja el carrito por debajo del umbral. Con el
   descuento puesto, el envío no es gratis hasta un subtotal de ~$184.286.
   Por eso aquí hay DOS hitos y se habla SIEMPRE del siguiente que falta:
     · el -30%       → mínimo del descuento, sobre el SUBTOTAL (antes de descuentos)
     · envío gratis  → condición de la tarifa, sobre el TOTAL (después de descuentos)

   🔒 NUNCA SE AFIRMA UN DESCUENTO QUE NO SE VE EN EL CARRITO. El estado «ya lo tienes»
      se decide por OBSERVACIÓN (`cart_level_discount_applications`), no por aritmética:
      la aritmética es una predicción y la observación es un hecho. Y el porcentaje que
      se anuncia como conseguido es el que el carrito trae, no una constante.

   🔒 EL «TE FALTAN» DEL ENVÍO ESTÁ EN DINERO QUE EL CLIENTE PUEDE AGREGAR. Con el -30%
      puesto, cada $100 de producto sólo mueven el total $70: decir «te faltan $29.670»
      (la resta pelada) haría que el cliente los agregue y la barra siguiera diciendo que
      falta — o peor, que dijera «gratis» sin serlo. Se divide por el factor que el propio
      carrito declara (`value_type: percentage`), así que un descuento de importe fijo
      —que no escala— sale con factor 1, que es lo correcto para ese caso.

   🔒 Y CUANDO LA ESCALA NO ES UNA RECTA, NO SE PREDICE NADA: SE DICE EL UMBRAL.
      Ése es el arreglo del 10-sep, y sale de una medición, no de una intuición. El 2x1 no
      es un porcentaje sobre el carrito: es una ESCALERA por cantidad, y cada peldaño
      cambia el descuento de TODAS las unidades. Medido en la tienda viva con carritos
      reales de PULSERA ALINEACIÓN 7 CHAKRAS ($69.000 de lista), preguntándole a Shopify
      sus tarifas (`/cart/shipping_rates.json`):

        2 uds → lista $138.000 · «2 uds -50%»  → total  $69.000 → ENVIO $17.700
        3 uds → lista $207.000 · «3+ uds -55%» → total  $93.150 → ENVIO $17.700
        4 uds → lista $276.000 · «3+ uds -55%» → total $124.200 → ENVIO $17.700
        5 uds → lista $345.000 · «3+ uds -55%» → total $155.250 → ENVIO GRATIS $0

      Con 2 uds la barra decía «te faltan $60.000» (la resta pelada: 129.000 − 69.000) y
      el cliente que agregaba UNA unidad más —$69.000 de lista, o sea MÁS de lo que la
      barra pidió— seguía pagando los $17.700, y la barra le volvía a pedir dinero. Para
      llegar de verdad hacen falta 3 unidades más: $207.000, o sea 3,45× lo pedido.

      ⚠️ Y LA OTRA SALIDA TENTADORA TAMBIÉN ES FALSA, medida igual: derivar el factor del
      propio carrito (`total_price ÷ original_total_price` = 69.000 ÷ 138.000 = 0,5) da
      «te faltan $120.000»… y con $138.000 agregados (4 uds) el total llega a $124.200 y
      el envío SIGUE costando $17.700. Es una predicción menos falsa, no una verdad. Y
      encima rompería el caso del descuento de IMPORTE FIJO, que no escala: ahí ese
      cociente da un factor < 1 cuando el correcto es 1.

      Así que en cuanto el carrito trae UN descuento de LÍNEA (que es la firma de la
      escalera; el 2x1 llega en `items[].line_level_discount_allocations` y deja
      `cart_level_discount_applications` VACÍO), `faltaParaEnvioGratis` devuelve `null` —
      no un número— y el texto pasa a decir el UMBRAL OBSERVADO: «el envío es GRATIS
      cuando el total llega a $129.000 — vas en $69.000». Los dos datos son hechos: el
      umbral es la condición de la tarifa y el «vas en» es `total_price`. El `null` es
      deliberado: obliga a cualquier consumidor futuro a decidir qué hace, en vez de
      dejarle a mano un número que se equivoca por 3,45×.

   🔒 SI ALGO FALLA, NO SE PINTA. La caja nace `hidden` en el Liquid y sólo se destapa
      cuando `/cart.js` contestó. Un número inventado en una barra de promesas es peor
      que no tener barra.

   ═══════════════════════════════════════════════════════════════════════════
   Y DESDE EL 10-sep ESTE ARCHIVO GOBIERNA TAMBIÉN EL MODO DE LA MARQUESINA
   ═══════════════════════════════════════════════════════════════════════════
   La franja de arriba (sections/marquesina-co.liquid) tiene dos textos: el de la tienda,
   que nombra el -30%, y el del 2x1, que no puede nombrarlo. Su Liquid siembra el modo
   por la PÁGINA y por el CONTENIDO del carrito, pero el carrito de Dawn cambia por AJAX
   y sin recargar, así que la decisión VIVA la toma `modoEfectivo` —la misma que decide
   esta barra— y `sincronizarMarquesina` la aplica. Un solo sitio que decide: si cada
   pieza tuviera su regla, un día dirían lo contrario en la misma pantalla (medido el
   10-sep en el preview: carrito 100 % 2x1 → la franja prometía el -30% y esta barra ya
   estaba en modo B).
   Y el UMBRAL viaja al revés: lo publica la franja (`data-ccq-umbral`, del ajuste del
   editor de temas) y lo lee `umbralDeLaPagina`; el `data-ccm-meta` del Liquid es el
   respaldo de las páginas donde la franja no se pinta.

   Las decisiones viven en funciones PURAS expuestas en `window.__ccoMeta` (costura de
   prueba: la sección 25 de scripts/test-cod-co-tema.mjs las ejerce sin DOM y sin red, y
   el satélite scripts/test-cod-co-ajustes.mjs ejerce las dos piezas juntas en un DOM).
   Cero `setInterval`: el refresco se cuelga de los eventos del carrito.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // $129.000 COP en centavos. Shopify guarda COP ×100 — medido: el BRAZALETE AMAZONITA,
  // que vale $47.300, llega como 4730000 en /products/*.js y en /cart.js.
  var META_DEF = 12900000;
  // El porcentaje PROMETIDO mientras aún no se alcanza (el conseguido se lee del carrito).
  var PCT_DEF = 30;
  // No va con el -30% normal: se vende con venta flash propia (nota §13 del dueño). Fuera
  // de las sugerencias, y su ficha no pinta barra (eso lo decide el Liquid).
  var COLIBRI = '✨-coleccion-alma-de-colibri-✨-collar-y-aretes';
  var TOPE_SUG = 8;

  // ── EL CORTE DEL -30% (dueño, promo hasta el domingo 20-sep-2026) ──────────
  // 2026-09-21T05:00:00Z = domingo 20-sep 24:00 hora Colombia = lunes 21-sep 00:00 COT
  // (Colombia va en UTC-5 todo el año, sin horario de verano: el número se escribe una
  // vez y no se mueve con la fecha del visitante). MISMO literal que `promo30-co.js`
  // (`CORTE_DEFECTO`) — los dos assets son `defer` independientes y no hay un módulo
  // compartido entre ellos; el barrido de la suite vigila que los dos strings coincidan.
  //
  // 🔒 A PARTIR DE AQUÍ, NINGÚN TEXTO PUEDE NOMBRAR UN PORCENTAJE PROMETIDO. No se tocó
  //    `modoEfectivo` (sigue devolviendo sólo 'a'/'b', igual que siempre: el 2x1 —modo
  //    B— conserva su texto entero, con o sin promo, porque nunca prometió el -30%) ni
  //    la ESTRUCTURA de `texto()`/`pct()`/`estado()`. Se gatearon los TRES sitios que
  //    fabrican la promesa, cada uno con un candado de una línea:
  //      (1) `hitoPendiente` deja de devolver 'desc' → el texto "Solo te faltan… -30%"
  //          (y su gemelo en `textoSubtotal`) quedan ESTRUCTURALMENTE inalcanzables,
  //          porque los dos ramifican sobre el MISMO valor que esta función calcula UNA
  //          vez (el comentario "UNA sola decisión, DOS consumidores" de más arriba);
  //      (2) `faltaParaEnvioGratis` cae a `null` en modo A igual que ya hacía en modo B
  //          → el texto pasa a decir sólo el umbral («el envío es GRATIS cuando el total
  //          llega a…»), sin predecir un delta —que es justo el pedido: «se comporta
  //          como en modo b»—;
  //      (3) `precioTarjeta` deja de fabricar el precio CONDICIONAL («con -30%: $X») en
  //          la caja de sugerencias → cae al precio de lista simple, y como `pintarSugerencias`
  //          sólo enciende la nota «El precio con -30% se aplica…» cuando hay un precio
  //          `condicional`, la nota se apaga SOLA, sin tocar esa función.
  //    Lo que SIGUE mostrando un porcentaje después del corte es el OBSERVADO —el carrito
  //    ya trae un descuento activo de verdad (`descuentoMeta`/`porcentajeCarrito`)—, y es
  //    correcto que siga: eso no es una promesa nuestra, es lo que el checkout va a cobrar
  //    en este momento. Apagar un HECHO sería mentir en la dirección contraria.
  var CORTE_30 = Date.parse('2026-09-21T05:00:00Z');
  function ahoraGate() {
    return typeof window.__CO_PROMO30_AHORA === 'number' ? window.__CO_PROMO30_AHORA : Date.now();
  }
  // Fail-safe hacia el lado que no cuesta dinero: si `CORTE_30` no pudiera parsearse
  // (typo en el literal de arriba) `NaN >= NaN` es `false`, así que `promoVigente()`
  // devolvería SIEMPRE `true` — la promo seguiría viva en vez de apagarse sola. Es el
  // mismo criterio que ya eligió `promo30-co.js` para su propio corte: mejor un fallo que
  // deja la promo encendida de más (se corrige a mano) que uno que la apaga sin que nadie
  // lo pidiera.
  function promoVigente() {
    return !(ahoraGate() >= CORTE_30);
  }
  // UN SOLO re-chequeo, programado para el instante exacto del corte — no un
  // `setInterval` continuo: con el corte ya pasado no se programa nada (`restante
  // <= 0`, nada que esperar), y tampoco cuando falta más de lo que un `setTimeout`
  // puede esperar (ver TECHO, abajo — nadie deja una pestaña abierta 25 días; el
  // próximo `refrescar()`/carga de página ya reevalúa `promoVigente()` con el reloj
  // real). Así el apagado de la marquesina y de la barra de meta ocurre EN VIVO, sin
  // recargar, aunque el cliente no toque el carrito.
  //
  // 🔒 EL TECHO ES EL DEL PROPIO `setTimeout`, NO "30 DÍAS" (corrección 18-sep, revisión
  //    adversaria): el retardo viaja como entero de 32 bits con signo, así que todo lo
  //    que pase de 2^31−1 ms (≈24,85 días) DESBORDA y el navegador lo dispara DE
  //    INMEDIATO. Con un guard de "30 días", entre 24,85 y 30 días antes del corte el
  //    callback habría corrido al instante — y con él `refrescarPronto` en cada carga.
  //    Por debajo del techo el corte cabe entero, sin cuenta que hacer.
  var TECHO_SETTIMEOUT_MS = 2147483647;
  function programarRecorte(cb) {
    var restante = CORTE_30 - ahoraGate();
    if (!(restante > 0) || restante + 250 > TECHO_SETTIMEOUT_MS) return;
    setTimeout(cb, restante + 250);
  }

  // ── DINERO ────────────────────────────────────────────────────────────────
  // Mismo criterio que `fmtCop` de puente-landing-co.js (punto de miles, sin decimales,
  // sin «COP»); no se importa porque son dos assets independientes y aquí la entrada son
  // CENTAVOS, no un texto que haya que reinterpretar.
  function copDeCentavos(cent) {
    var pesos = Math.round(num(cent) / 100);
    return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function num(v) {
    var n = Number(v);
    if (!isFinite(n) || n < 0) return 0;
    return n;
  }
  function metaValida(meta) {
    var m = num(meta);
    return m > 0 ? m : META_DEF;
  }

  // ── EL UMBRAL, DE UN SOLO SITIO (arreglo del 10-sep) ──────────────────────
  // El monto vive en el ajuste «Monto desde el que el envío es gratis» de la MARQUESINA
  // (sections/marquesina-co.liquid), que lo publica en `data-ccq-umbral` en PESOS. Antes
  // el mismo número estaba escrito además en el `data-ccm-meta` de meta-co.liquid, y
  // mover el del editor de temas dejaba la tienda diciendo dos umbrales distintos en la
  // misma pantalla (la marquesina prometiendo uno y esta barra calculando con el otro).
  // Ahora hay UNA palanca; el atributo del Liquid es el RESPALDO para las páginas donde
  // la franja no se pinta (interruptor en `false`, o texto vacío).
  //
  // 🔒 SE VALIDA CONTRA EL RESPALDO, Y NO ES CELO: este número DIVIDE (`pct`) y RESTA
  //    (`faltaPara…`), o sea que mueve lo que la barra le PROMETE al cliente. Un dedazo
  //    típico es de 10× —«$12.900» por «$129.000»— y con él la barra diría «envío GRATIS»
  //    a casi cualquier carrito: la clase de promesa falsa que este carril tiene prohibida
  //    de raíz (emergencia del 05-jul). Así que se acepta el ajuste sólo si cae dentro de
  //    un factor 4 del número MEDIDO de la tarifa (el respaldo del Liquid): un cambio real
  //    del umbral cabe de sobra (129.000 → de 32.250 a 516.000) y los dedazos de 10× no.
  //    Fuera de la banda —o sin dígitos— se usa el respaldo, que es el dato medido.
  //    Si algún día hay que salirse de la banda, se cambian los DOS números; el assert
  //    33.d ya obliga a que en el repo sean el mismo.
  var UMBRAL_FACTOR = 4;
  function umbralPublicado(txt, respaldo) {
    var base = num(respaldo) || META_DEF;
    var s = String(txt === undefined || txt === null ? '' : txt).replace(/[^\d]/g, '');
    if (!s) return 0;
    var cent = Number(s) * 100;
    if (!isFinite(cent) || cent <= 0) return 0;
    if (cent * UMBRAL_FACTOR < base) return 0;
    if (cent > base * UMBRAL_FACTOR) return 0;
    return cent;
  }

  // ── LO QUE DICE EL CARRITO ────────────────────────────────────────────────
  // SUBTOTAL, antes de descuentos: es lo que mira el mínimo del -30% (medido: a $94.600
  // no hay descuento, a $141.900 sí).
  function preDe(cart) {
    if (!cart) return 0;
    return num(cart.original_total_price) || num(cart.items_subtotal_price) || num(cart.total_price);
  }
  // TOTAL, después de descuentos: es lo que mira la condición de la tarifa de envío.
  function postDe(cart) { return cart ? num(cart.total_price) : 0; }

  function aplicacionesCarrito(cart) {
    var a = cart && cart.cart_level_discount_applications;
    return Object.prototype.toString.call(a) === '[object Array]' ? a : [];
  }
  // EL DESCUENTO DE LA META, POR OBSERVACIÓN. Se busca una aplicación de NIVEL CARRITO en
  // porcentaje, no un título: el título es una etiqueta editable en el panel y colgar de
  // él dejaría la barra mintiendo en silencio el día que alguien lo renombre.
  // Medido el 09-sep: el -30% «A&M❤️» llega aquí (value_type percentage, value "30.0",
  // target_selection "all"); el descuento del 2x1 NO —es de LÍNEA y este array viene
  // vacío—, que es justo la separación que hace falta.
  function descuentoMeta(cart) {
    var a = aplicacionesCarrito(cart);
    for (var i = 0; i < a.length; i++) {
      if (String(a[i] && a[i].value_type) === 'percentage' && num(a[i].value) > 0) return a[i];
    }
    return null;
  }
  // El porcentaje que el carrito declara, para (a) anunciar el conseguido y (b) el factor.
  function porcentajeCarrito(cart) {
    var a = aplicacionesCarrito(cart), t = 0;
    for (var i = 0; i < a.length; i++) {
      if (String(a[i] && a[i].value_type) === 'percentage') t += num(a[i].value);
    }
    return t > 99 ? 99 : t;
  }

  // ¿HAY DESCUENTOS DE LÍNEA? Es la firma de una promoción por CANTIDAD (el 2x1), y con
  // ella la relación «dinero de lista que agrego» ↔ «total» deja de ser una recta: es una
  // escalera cuyos peldaños NO viajan en /cart.js (Shopify manda el descuento aplicado,
  // no el escalado de precios que lo generó). Se mira el ARTÍCULO, no el título.
  // 🐛 Y LAS SEÑALES HAY QUE ELEGIRLAS MIDIENDO, no por su nombre: el primer intento de
  // este arreglo también miraba `discounts` y `total_discount` del artículo, y ESO HABRÍA
  // ROTO EL MODO A. Medido el 10-sep en el MISMO carrito de 3 × BRAZALETE AMAZONITA con
  // el -30% de NIVEL CARRITO puesto:
  //     items[0].discounts                     = [{amount: 4257000, title: 'A&M❤️'}]  ← ¡lleno!
  //     items[0].total_discount                = 4257000                              ← ¡lleno!
  //     items[0].line_level_discount_allocations = []
  //     items[0].line_level_total_discount     = 0
  // O sea: `discounts` y `total_discount` transportan los DOS tipos de descuento y no
  // separan nada; con ellos, el carrito verificado de la banda ($141.900 → «te faltan
  // $42.386», correcto) habría dejado de dar su número. Contra el carrito 2x1 de 2 uds:
  //     line_level_discount_allocations = [1 asignación «2 uds -50%»]   line_level_total_discount = 6.900.000
  // Los dos campos con `line_level` en el nombre son los únicos que discriminan, y se
  // aceptan los dos porque son el mismo hecho por dos puertas (basta uno).
  // La DIRECCIÓN del fallo también es deliberada: detectar de más sólo cuesta dejar de
  // predecir —y decir el umbral, que siempre es verdad—; no detectar sería volver a
  // prometer un envío gratis que el checkout no va a dar.
  function hayDescuentoDeLinea(cart) {
    var it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) {
      var l = it[i] || {};
      var a = l.line_level_discount_allocations;
      if (Object.prototype.toString.call(a) === '[object Array]' && a.length > 0) return true;
      if (num(l.line_level_total_discount) > 0) return true;
    }
    return false;
  }
  // La escala es una RECTA sólo si todo lo que descuenta el carrito es de nivel carrito.
  function escalaLineal(cart) { return !hayDescuentoDeLinea(cart); }

  // ── LOS DOS HITOS ─────────────────────────────────────────────────────────
  function faltaParaDescuento(cart, meta) {
    if (descuentoMeta(cart)) return 0;
    var m = metaValida(meta);
    return Math.max(0, m - preDe(cart));
  }
  // Devuelve CENTAVOS, 0 si ya está conseguido… o `null` cuando NO se puede predecir
  // (hay descuentos de LÍNEA → escalera; ver el candado de la cabecera, con la medición).
  //
  // 🔒 FIX 11-sep (hallazgo ALTO del escéptico): EN MODO B NUNCA SE PREDICE UN DELTA,
  //    con independencia de lo que traiga el carrito. Antes la única guarda era
  //    `!escalaLineal(cart)`, y esa firma (`line_level_discount_allocations`) NO EXISTE
  //    hasta que el 2x1 YA está en el carrito — así que en la ficha (carrito vacío, o con
  //    un solo artículo normal) `modoEfectivo` ya decía 'b' pero el carrito aún parecía
  //    «lineal» y la barra predecía con factor 1: «Solo te faltan $129.000…», falso, el
  //    2x1 no da envío gratis por $129.000 de LISTA (hacen falta ~2,67-3,45× eso, medido
  //    en la cabecera del archivo). El modo es la señal correcta — no depende de que el
  //    carrito ya haya cruzado el umbral que detona el descuento de línea — así que se
  //    mira PRIMERO y sin excepción.
  function faltaParaEnvioGratis(cart, meta, modo) {
    var m = metaValida(meta), post = postDe(cart);
    if (post >= m) return 0;
    // `!promoVigente()` se suma al MISMO `if` que ya trataba el modo B como "no se
    // predice un delta": tras el corte, el modo A se comporta igual — se dice sólo el
    // umbral observado, nunca una resta que hoy dependería de un -30% que ya no rige.
    if (modo === 'b' || !escalaLineal(cart) || !promoVigente()) return null;
    var factor = (100 - porcentajeCarrito(cart)) / 100;
    if (!(factor > 0)) factor = 1;
    // Se redondea al peso HACIA ARRIBA: pedir un peso de más nunca rompe la promesa,
    // pedir uno de menos sí (el cliente agrega lo que dice la barra y no le alcanza).
    return Math.ceil((m - post) / factor / 100) * 100;
  }
  // ── EL HITO DEL QUE SE HABLA ──────────────────────────────────────────────
  // UNA sola decisión, DOS consumidores (el texto y la barra). Si cada uno la tomara por
  // su cuenta se desincronizarían: la barra hablando de un hito y la frase de otro, que es
  // exactamente el tipo de incoherencia que nadie ve en un grep y sí en la pantalla.
  //   'desc'  → falta el descuento (sólo existe en modo A: en modo B no se promete)
  //   'envio' → falta el envío gratis
  //   null    → no falta nada
  function hitoPendiente(cart, meta, modo) {
    var m = metaValida(meta);
    if (postDe(cart) >= m) return null;
    // `promoVigente()` primero: tras el corte no hay ningún -30% que prometer, así que
    // el hito 'desc' —y con él, todo texto que nombre un porcentaje PROMETIDO— queda
    // estructuralmente inalcanzable (ver la nota larga junto a `CORTE_30`, arriba).
    if (promoVigente() && modo !== 'b' && !descuentoMeta(cart) && faltaParaDescuento(cart, m) > 0) return 'desc';
    return 'envio';
  }

  // LA BARRA NO PUEDE RETROCEDER, y ésa es la razón de que tenga DOS TRAMOS en modo A.
  // Con una sola escala (progreso = total ÷ meta) pasa esto: el carrito llega a $129.000
  // y la barra marca 100%… y en ese mismo instante entra el -30%, el total baja a $90.300
  // y la barra CAE al 70%. Una barra que retrocede justo cuando el cliente consiguió algo
  // se lee como un error de la tienda, no como un premio.
  // Así que en modo A el recorrido son los dos hitos: 0-49% mientras falta el descuento,
  // 50-99% mientras falta el envío, 100% cuando está todo. Al conseguir el descuento la
  // barra SALTA de ~49 a ~85: hacia adelante. En modo B hay UN hito y la escala es entera.
  function pct(cart, meta, modo) {
    var m = metaValida(meta);
    var tope = function (v, max) {
      if (!isFinite(v) || v < 0) return 0;
      return v > max ? max : v;
    };
    var h = hitoPendiente(cart, meta, modo);
    if (h === null) return 100;
    if (h === 'desc') return tope(Math.round(50 * preDe(cart) / m), 49);
    // 🐛 (26-oct, dueño punto 11) Tras el corte del -30% NO hay primer tramo: el modo A
    // tiene UN solo hito (el envío) y la escala es entera, igual que el B. Sin esto la
    // barra salía MEDIO LLENA con «vas en $0» en las 58 fichas sin 2x1.
    if (modo === 'b' || !promoVigente()) return tope(Math.round(100 * postDe(cart) / m), 99);
    return 50 + tope(Math.round(50 * postDe(cart) / m), 49);
  }
  function estado(cart, meta, modo) {
    var m = metaValida(meta);
    return {
      desc: !!descuentoMeta(cart),
      pctReal: Math.round(porcentajeCarrito(cart)),
      envio: postDe(cart) >= m,
      hito: hitoPendiente(cart, m, modo),
      faltaDesc: faltaParaDescuento(cart, m),
      // `null` = no se puede predecir cuánto falta (escalera, o modo B). Lo decide UN
      // solo sitio, y ahora también con el MODO (fix 11-sep).
      faltaEnvio: faltaParaEnvioGratis(cart, m, modo),
      escala: escalaLineal(cart),
      // El total OBSERVADO, para poder decir «vas en …» sin volver a leer el carrito.
      total: postDe(cart),
      meta: m,
      pct: pct(cart, m, modo),
    };
  }

  // ── EL TEXTO ──────────────────────────────────────────────────────────────
  // 🔒 EL MODO B NUNCA NOMBRA EL DESCUENTO. El 2x1 no es acumulable (regla del dueño del
  //    04-sep, ya cableada en skin-landing-co.css) y en un carrito 2x1 el -30% es
  //    justo lo que el comprador NO va a recibir. La estructura lo garantiza: la única
  //    rama que menciona un porcentaje exige `modo === 'a'` o un descuento OBSERVADO,
  //    y en modo B no se entra a ninguna de las dos.
  function texto(modo, cart, meta, money, pctPromesa) {
    var e = estado(cart, meta, modo);
    var f = typeof money === 'function' ? money : copDeCentavos;
    var prom = num(pctPromesa) || PCT_DEF;
    var esB = modo === 'b';
    if (e.hito === 'desc') {
      return 'Solo te faltan ' + f(e.faltaDesc) + ' para tu -' + prom + '% ❤️';
    }
    if (e.hito === 'envio') {
      // ESCALERA (2x1 y cualquier descuento de LÍNEA): no se predice un delta que se
      // equivoca por 3,45× — se dicen los DOS hechos, el umbral de la tarifa y dónde va
      // el carrito. Se decide por el DATO (`e.escala`), no por el modo: un carrito de
      // modo A con un descuento por cantidad tampoco es una recta.
      if (e.faltaEnvio === null) {
        // Carrito VACÍO en modo B (ficha 2x1 sin nada agregado todavía): no hay un
        // «vas en» que decir — «vas en $0» suena a error de la tienda. Se invita a
        // empezar en vez de mostrar un cero.
        // 🔒 El texto SIN carrito vacío se deja BYTE A BYTE como estaba («cuando el
        //    total llega a…»): test-cod-co-tema.mjs (archivo prohibido, 28.* y otros)
        //    fija esa cadena exacta en varios sitios; sólo la rama NUEVA (carrito vacío,
        //    sin cobertura previa) usa la redacción del dictado del dueño («tu total»).
        var vacio = esB && !(cart && cart.items && cart.items.length);
        var umbral = vacio
          ? 'El envío es GRATIS cuando tu total llega a ' + f(e.meta) +
            ' — agrega productos para empezar 🍃'
          : 'El envío es GRATIS cuando el total llega a ' + f(e.meta) +
            ' — vas en ' + f(e.total) + ' 🍃';
        if (!esB && e.desc) return '¡Ya tienes -' + e.pctReal + '% ❤️! ' + umbral;
        return umbral;
      }
      if (!esB && e.desc) {
        return '¡Ya tienes -' + e.pctReal + '% ❤️! Te faltan ' + f(e.faltaEnvio) +
               ' para el envío GRATIS 🍃';
      }
      return 'Solo te faltan ' + f(e.faltaEnvio) + ' para tu envío GRATIS 🍃';
    }
    if (!esB && e.desc) {
      return '¡Felicidades! Tienes -' + e.pctReal + '% ❤️ y envío GRATIS 🍃';
    }
    return '¡Felicidades! Tu envío es GRATIS 🍃';
  }

  // ── EL MODO ───────────────────────────────────────────────────────────────
  // En la FICHA lo decide el Liquid (¿este producto está en la colección 2x1?). En el
  // CARRITO no hay producto, así que se decide por el CONTENIDO.
  //
  // 🔴 EL CARRITO MEZCLADO VA A MODO TIENDA (dictado del dueño 10-sep, notas §18.3), y
  //    esto es un CAMBIO DE CONDUCTA respecto del 09-sep: hasta hoy bastaba UN artículo
  //    del 2x1 para pasar a B. La razón escrita entonces era conservadora —no prometer
  //    un descuento cuya combinación decide Shopify—, pero la propia medición del 09-sep
  //    apuntaba al revés: en un carrito grande con un 2x1 dentro, Shopify aplicó el -30%
  //    y NO el 2x1. Así que en un carrito mezclado el modo tienda es lo que el checkout
  //    va a hacer, y el modo B sería la promesa falsa.
  //    ⚠️ Y el modo B NO es «más seguro por defecto»: allí NO se nombra el -30% y se dice
  //    el UMBRAL en vez de un delta, así que en un carrito mezclado que sí lleva el -30%
  //    el modo B le esconde al cliente el descuento que YA tiene.
  //
  // 🔌 QUEDA PARAMETRIZADO, no cableado: el 4º argumento sale de un atributo del Liquid
  //    (`data-ccm-mixto`). Con `"b"` se restaura exactamente la conducta vieja sin tocar
  //    una línea de código ni desplegar un asset — la propuesta del dueño está aprobada
  //    pero es reversible, y ésta es la palanca.
  //
  //   sólo 2x1  → 'b'     ·  sólo tienda → 'a'  ·  vacío → 'a'
  //   MEZCLADO  → 'a'  (o 'b' si el Liquid declara `data-ccm-mixto="b"`)
  function modoEfectivo(base, cart, ids2x1, mixto) {
    if (base === 'b') return 'b';
    var ids = {}, i;
    for (i = 0; i < (ids2x1 || []).length; i++) ids[String(ids2x1[i])] = 1;
    var it = (cart && cart.items) || [];
    if (!it.length) return 'a';
    var con = 0, sin = 0;
    for (i = 0; i < it.length; i++) {
      if (ids[String(it[i] && it[i].product_id)]) con++; else sin++;
    }
    if (!con) return 'a';
    if (!sin) return 'b';
    return mixto === 'b' ? 'b' : 'a';
  }

  // ── LA ETIQUETA DE LA SUGERENCIA (dueño §4: «etiqueta de descuento») ───────
  // Modo B: «2x1» SIEMPRE — esos productos llevan de verdad el descuento por cantidad,
  // es un hecho de la colección, no una predicción.
  // Modo A: «-N%» SÓLO si el carrito YA TRAE el descuento observado, y con el
  // porcentaje que el propio carrito declara. Mientras no lo tenga, NINGUNA etiqueta:
  // el -30% depende de un mínimo de subtotal y la frase de la barra ya dice cuánto
  // falta. Un «-30%» pegado a una foto es una PROMESA, y este carril tiene prohibido
  // prometer lo que el checkout no va a cumplir (emergencia del 05-jul).
  // ⚠️ Se lee del carrito, no del `data-ccm-pct` del Liquid: ese 30 es lo que se ANUNCIA
  //    como pendiente, y usarlo aquí haría que la etiqueta mintiera el día que el
  //    descuento vivo no sea el mismo número.
  function etiquetaSug(modo, cart) {
    if (modo === 'b') return '2x1';
    var pr = Math.round(porcentajeCarrito(cart));
    return pr > 0 ? '-' + pr + '%' : '';
  }

  // ── EL PRECIO DE LA TARJETA (dueño §3/§7, ronda 2, 11-sep) ─────────────────
  // Hasta hoy la tarjeta mostraba sólo el precio de lista. El dueño pidió el precio
  // TACHADO + lo que queda:
  //   · modo B (2x1, §3): «2 por $X» — es el HECHO que aplica el checkout (2 unidades
  //     cuestan lo que costaba 1; medido con la pulsera de $69.000: 2 uds → $69.000). El
  //     tachado es lo que costarían las 2 SIN la oferta (2×precio).
  //   · modo A (tienda, §7): «con -30%: $X» — es una PROMESA CONDICIONAL (se gana al
  //     llegar a la meta), y por eso `condicional:true` viaja aparte: quien lo pinte tiene
  //     que aclararlo, nunca mostrarlo como un hecho.
  // 🔒 NUNCA hardcodea el -30% si el carrito YA LO TRAE observado (`pctRealCarrito`): ahí
  //    se usa el porcentaje REAL del carrito, que es un hecho (igual que hace
  //    `etiquetaSug`), y el resultado NO es condicional.
  // `puro2x1` (opcional, default true): FALSO cuando el carrito YA tiene, además del
  // producto sugerido, artículos que NO son del 2x1 — ahí Shopify puede aplicar el -30%
  // en vez del 2x1 (medido: `combinesWith` de los 45 descuentos ACTIVE es todo `false`,
  // así que actúa UNO solo, y con el resto del carrito grande el -30% gana). «2 por $X»
  // sería entonces una promesa que el checkout no cumple, así que se cae al precio DE
  // LISTA simple (sin tachado): la etiqueta «2x1» la sigue poniendo `etiquetaSug` aparte.
  function precioTarjeta(modo, p, pctRealCarrito, puro2x1) {
    var precio = num(p && p.precio);
    if (!(precio > 0)) return null;
    if (modo === 'b') {
      if (puro2x1 === false) return null;
      return { tachado: copDeCentavos(precio * 2), final: '2 por ' + copDeCentavos(precio), condicional: false };
    }
    var pr = num(pctRealCarrito);
    if (pr > 0) {
      return {
        tachado: copDeCentavos(precio),
        final: copDeCentavos(Math.round(precio * (100 - pr) / 100)),
        condicional: false,
      };
    }
    // Tras el corte no queda ningún -30% que PROMETER: `null` hace que `tarjeta()` caiga
    // a su rama de precio de lista simple (la caja adicional "muestra sólo su precio
    // normal"), y como esto es lo único que puede devolver `condicional:true`,
    // `pintarSugerencias` apaga la nota «El precio con -30% se aplica…» SOLA, sin tocar
    // esa función (ver la nota larga junto a `CORTE_30`, arriba).
    if (!promoVigente()) return null;
    return {
      tachado: copDeCentavos(precio),
      final: 'con -' + PCT_DEF + '%: ' + copDeCentavos(Math.round(precio * (100 - PCT_DEF) / 100)),
      condicional: true,
    };
  }

  // ── LA LÍNEA DEL SUBTOTAL, SÓLO EN EL CARRITO (dueño §12, ronda 2, 11-sep) ─
  // «con un pedido que pasa los $129.000 sólo si se suma el envío, la gente ve el TOTAL y
  // no entiende por qué no tiene envío gratis […] aclarar que el que cuenta es el
  // subtotal». `e.total` es `postDe(cart)` — el MISMO número que Dawn pinta como
  // «Subtotal» en `/cart` (`cart.total_price`, verificado en vivo: $99.330 en los dos
  // sitios con el mismo carrito) — así que decir «tu subtotal es …» aquí no inventa un
  // dato nuevo: nombra el que YA está en la pantalla.
  function textoSubtotal(modo, cart, meta) {
    var e = estado(cart, meta, modo);
    var f = copDeCentavos;
    var base = 'Tu subtotal es ' + f(e.total) + '; ';
    if (e.hito === null) return 'Tu subtotal es ' + f(e.total) + ' — ¡ya tienes todo! 🍃';
    if (e.hito === 'desc') return base + 'te faltan ' + f(e.faltaDesc) + ' para tu -' + PCT_DEF + '% ❤️';
    if (e.faltaEnvio === null) {
      return 'Tu subtotal es ' + f(e.total) + ' — el envío es GRATIS cuando el total llega a ' + f(e.meta) + ' 🍃';
    }
    return base + 'te faltan ' + f(e.faltaEnvio) + ' para el envío GRATIS 🍃';
  }

  // ── EL TEXTO DEL **CARRITO** (dictado del dueño, 21-oct-2026) ─────────────
  // «En la barra de envío gratis del carrito dice "El envío es GRATIS cuando el total
  //  llega a $129.000 — vas en $124.700" y repite debajo "Tu subtotal es…". Que diga lo
  //  mismo que el formulario.» → título «Te faltan $4.300 para tu envío GRATIS 🍃» y
  //  debajo «Llevas $124.700 de $129.000». MISMOS números que antes (el umbral y el total
  //  OBSERVADO, `total_price`): sólo cambia la frase. Al llegar, el mensaje de envío
  //  gratis conseguido de siempre (`texto`).
  // 🔒 SÓLO EN EL CARRITO: la ficha sigue con `texto()` byte a byte.
  // La cifra: si `faltaParaEnvioGratis` sabe predecir el delta (carrito lineal) se usa esa
  // —la de siempre—; si no (escalera, o tras el corte del -30%), la resta de los dos
  // hechos que ya se pintaban: umbral − total observado.
  function faltaCarrito(e) {
    if (e.faltaEnvio !== null && e.faltaEnvio !== undefined) return e.faltaEnvio;
    var d = num(e.meta) - num(e.total);
    return d > 0 ? d : 0;
  }
  function carritoConArticulos(cart) { return !!(cart && cart.items && cart.items.length); }
  function textoCarrito(modo, cart, meta, money, pctPromesa) {
    var e = estado(cart, meta, modo);
    if (e.hito !== 'envio' || !carritoConArticulos(cart)) return texto(modo, cart, meta, money, pctPromesa);
    var f = typeof money === 'function' ? money : copDeCentavos;
    return 'Te faltan ' + f(faltaCarrito(e)) + ' para tu envío GRATIS 🍃';
  }
  function textoSubtotalCarrito(modo, cart, meta) {
    var e = estado(cart, meta, modo);
    if (e.hito !== 'envio' || !carritoConArticulos(cart)) return textoSubtotal(modo, cart, meta);
    return 'Llevas ' + copDeCentavos(e.total) + ' de ' + copDeCentavos(e.meta);
  }

  // ── LAS SUGERENCIAS ───────────────────────────────────────────────────────
  function filtrarSugerencias(lista, opts) {
    var o = opts || {};
    var fuera = {}, i;
    for (i = 0; i < (o.handlesFuera || []).length; i++) fuera[String(o.handlesFuera[i])] = 1;
    var idsFuera = {};
    for (i = 0; i < (o.idsFuera || []).length; i++) idsFuera[String(o.idsFuera[i])] = 1;
    var vistos = {}, out = [];
    var tope = num(o.max) || TOPE_SUG;
    for (i = 0; i < (lista || []).length; i++) {
      var p = lista[i];
      if (!p) continue;
      var h = String(p.handle || '');
      var id = String(p.id || '');
      if (!h && !id) continue;
      if (fuera[h] || idsFuera[id] || vistos[id || h]) continue;
      vistos[id || h] = 1;
      out.push(p);
      if (out.length >= tope) break;
    }
    return out;
  }
  function imgChica(u) {
    var s = String(u || '');
    if (!s) return '';
    if (/[?&]width=\d+/.test(s)) return s;
    return s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
  }
  function normalizar(p) {
    return {
      id: p.id,
      handle: p.handle,
      titulo: p.titulo || p.title || '',
      url: p.url || (p.handle ? '/products/' + p.handle : ''),
      precio: num(p.precio != null ? p.precio : p.price),
      img: imgChica(p.img || p.featured_image || (p.images && p.images[0]) || ''),
    };
  }

  // ── DE AQUÍ PARA ABAJO, EL DOM ────────────────────────────────────────────
  window.__ccoMeta = {
    META_DEF: META_DEF, PCT_DEF: PCT_DEF, COLIBRI: COLIBRI,
    copDeCentavos: copDeCentavos, preDe: preDe, postDe: postDe,
    umbralPublicado: umbralPublicado, textoMarquesina: textoMarquesina,
    UMBRAL_FACTOR: UMBRAL_FACTOR,
    descuentoMeta: descuentoMeta, porcentajeCarrito: porcentajeCarrito,
    hayDescuentoDeLinea: hayDescuentoDeLinea, escalaLineal: escalaLineal,
    faltaParaDescuento: faltaParaDescuento, faltaParaEnvioGratis: faltaParaEnvioGratis,
    pct: pct, estado: estado, texto: texto, modoEfectivo: modoEfectivo,
    hitoPendiente: hitoPendiente, etiquetaSug: etiquetaSug,
    filtrarSugerencias: filtrarSugerencias, normalizar: normalizar, imgChica: imgChica,
    precioTarjeta: precioTarjeta, textoSubtotal: textoSubtotal,
    textoCarrito: textoCarrito, textoSubtotalCarrito: textoSubtotalCarrito,
    // El corte del -30% (dueño, promo hasta el 20-sep-2026): costura de prueba, molde
    // idéntico al resto de este objeto (funciones PURAS + la constante que gobiernan).
    CORTE_30: CORTE_30, promoVigente: promoVigente, modoMarquesina: modoMarquesina,
  };

  var caja = null;
  function laCaja() {
    if (!caja || !caja.isConnected) caja = document.querySelector('[data-ccm]');
    return caja;
  }
  // ── LA MARQUESINA (sections/marquesina-co.liquid) ─────────────────────────
  // Se pinta en TODAS las páginas desde el layout; esta barra sólo existe en las fichas
  // y en el carrito. Cuando coinciden, la que decide el modo es ESTA pieza (una sola
  // decisión viva): `modoEfectivo` ya lo calcula para la barra, así que la franja lo
  // copia en vez de tener su propia regla en Liquid, que podría separarse.
  function laMarquesina() { return document.querySelector('[data-ccq]'); }
  // El umbral con el que se hacen las cuentas: el de la franja si es válido, y si no el
  // respaldo del Liquid de esta barra.
  function umbralDeLaPagina(c) {
    var respaldo = metaValida(c ? c.getAttribute('data-ccm-meta') : null);
    var q = laMarquesina();
    var pub = q ? umbralPublicado(q.getAttribute('data-ccq-umbral'), respaldo) : 0;
    return pub || respaldo;
  }
  // PURA: qué texto le toca a este modo. Los TRES posibles viajan en el DOM (los escribió
  // el editor de temas), así que aquí no se compone ninguna frase: se elige uno. Un modo
  // desconocido o un texto vacío devuelven '' — y el llamador APAGA la franja, porque
  // enseñar el texto de otro modo es justo la promesa falsa que esto vino a quitar.
  function textoMarquesina(modo, textos) {
    if (modo !== 'a' && modo !== 'b' && modo !== 'c') return '';
    var t = textos ? textos[modo] : '';
    return String(t === undefined || t === null ? '' : t).trim();
  }
  // PURA: el modo 'a'/'b' de `modoEfectivo` (cart-aware) traducido al modo de PRESENTACIÓN
  // de la marquesina. 'b' (2x1) SIEMPRE conserva su texto —esa oferta no prometió el -30%,
  // así que el corte no le toca nada—; 'a' se convierte en 'c' tras el corte. NO se toca
  // `modoEfectivo`: éste sigue devolviendo sólo 'a'/'b' para el resto del archivo (la
  // barra de meta, sus hitos, su progreso), así que ningún otro consumidor se entera de
  // que existe un tercer estado — es puramente lo que la marquesina va a MOSTRAR.
  function modoMarquesina(modo) {
    if (modo === 'b') return 'b';
    return promoVigente() ? 'a' : 'c';
  }
  function sincronizarMarquesina(modoBase) {
    var q = laMarquesina();
    if (!q) return;
    var modo = modoMarquesina(modoBase);
    var lee = function (m) {
      var n = q.querySelector('[data-ccq-alt="' + m + '"]');
      return n ? n.textContent : '';
    };
    var txt = textoMarquesina(modo, { a: lee('a'), b: lee('b'), c: lee('c') });
    if (!txt) { q.style.display = 'none'; return; }
    q.style.display = '';
    // Las DOS copias, o el bucle enseñaría un texto distinto en cada vuelta. Se escribe
    // sólo si cambió: repintar el `textContent` en cada refresco del carrito reinicia el
    // reflujo de la pista y se ve un tirón en la animación.
    var copias = q.querySelectorAll('.ccq__t');
    for (var i = 0; i < copias.length; i++) {
      if (String(copias[i].textContent || '') !== txt) copias[i].textContent = txt;
    }
    // El modo de PRESENTACIÓN, no el de `modoEfectivo`: es lo que de verdad quedó pintado,
    // y es lo que la nota del Liquid ("si difiere de data-ccq-seed, la semilla llegó
    // rancia") necesita comparar en la vista previa.
    q.setAttribute('data-ccq-modo', modo);
  }
  // ── LA MARQUESINA EN PÁGINAS SIN BARRA DE META (home, colecciones, fichas 2x1) ────
  // `arrancar()` (más abajo) sólo hace algo si hay `[data-ccm]`, y la franja se pinta en
  // TODAS las páginas ("sin la semilla, ahí no habría ninguna decisión" — nota grande de
  // la marquesina, arriba). Aquí sólo se aplica el CORTE sobre lo que el Liquid YA decidió
  // (`data-ccq-seed`, el 'a'/'b' de siempre): nunca se re-deriva el modo por el contenido
  // del carrito — esa refinación cart-aware es exclusiva de `pintar()`/`modoEfectivo`, y
  // estas páginas no tienen producto ni meta bar de los que colgarla (limitación que el
  // propio diseño de la marquesina ya aceptaba antes de este cambio, no algo nuevo).
  function arrancarMarquesinaSola() {
    if (laCaja()) return;   // aquí ya se encarga `arrancar()` → `pintar()` → `sincronizarMarquesina`
    var q = laMarquesina();
    if (!q) return;
    var semilla = q.getAttribute('data-ccq-seed');
    if (semilla !== 'a' && semilla !== 'b') return;
    sincronizarMarquesina(semilla);
    programarRecorte(function () { sincronizarMarquesina(semilla); });
  }
  function lista2x1() {
    var n = document.querySelector('[data-ccm-2x1]');
    if (!n) return [];
    try {
      var j = JSON.parse(n.textContent || '[]');
      return Object.prototype.toString.call(j) === '[object Array]' ? j : [];
    } catch (e) { return []; }
  }

  // ⚠️ EL RÓTULO «Ver producto» SE RETIRÓ (dueño §4: «UN producto a la vez»). Con el
  //    carrusel, la tarjeta entera es el enlace y ocupa el ancho de la caja: un rótulo
  //    subrayado debajo del precio sólo sumaba una línea de alto a una barra que el
  //    dueño pidió COMPACTA. La tarjeta sigue siendo un `<a>`, así que no se pierde
  //    ninguna afordancia — se pierde el texto redundante.
  // `precioInfo` es lo que devuelve `precioTarjeta` (o `null`): {tachado, final}. Cuando
  // viaja, sustituye al precio de lista simple por el tachado + lo que queda (dueño
  // §3/§7); cuando no, se conserva EXACTAMENTE el comportamiento de siempre.
  function tarjeta(p, etq, precioInfo) {
    var a = document.createElement('a');
    a.className = 'ccm__c';
    a.href = p.url || '#';
    // Nada de innerHTML: el título viene de un producto y se escribe como TEXTO.
    if (p.img) {
      var im = document.createElement('img');
      im.className = 'ccm__img';
      im.src = p.img; im.alt = ''; im.loading = 'lazy';
      im.width = 160; im.height = 160;
      a.appendChild(im);
    }
    var t = document.createElement('span');
    t.className = 'ccm__ct'; t.textContent = p.titulo;
    a.appendChild(t);
    if (precioInfo && precioInfo.tachado && precioInfo.final) {
      var pr = document.createElement('span');
      pr.className = 'ccm__cp';
      var x = document.createElement('s');
      x.className = 'ccm__cx'; x.textContent = precioInfo.tachado;
      pr.appendChild(x);
      pr.appendChild(document.createTextNode(' '));
      var fnl = document.createElement('b');
      fnl.className = 'ccm__cf'; fnl.textContent = precioInfo.final;
      pr.appendChild(fnl);
      a.appendChild(pr);
    } else if (p.precio > 0) {
      var pr2 = document.createElement('span');
      pr2.className = 'ccm__cp'; pr2.textContent = copDeCentavos(p.precio);
      a.appendChild(pr2);
    }
    // La etiqueta la decide `etiquetaSug`, y puede venir VACÍA a propósito (modo A sin
    // el descuento observado): entonces no se pinta nada, no una píldora en blanco.
    if (etq) {
      var d = document.createElement('span');
      d.className = 'ccm__cd'; d.textContent = etq;
      a.appendChild(d);
    }
    return a;
  }

  // ── EL CARRUSEL: UN PRODUCTO A LA VEZ, CON FLECHAS (dueño §4) ──────────────
  // El DOM no cambia de contrato: se siguen pintando TODAS las tarjetas y el filtro
  // sigue mandando cuántas hay. Lo único que cambia es cuál se VE. Así el carrusel es
  // puro DOM —cero peticiones al mover las flechas— y los asserts que cuentan tarjetas
  // siguen midiendo lo mismo.
  // 🔒 NADA DE AUTO-AVANCE: el dueño pidió flechas, no un carrusel que se mueve solo.
  //    Un `setInterval` aquí, además, repintaría la caja mientras el cliente lee.
  var iSug = 0;
  function mostrarSug(n) {
    var c = laCaja(); if (!c) return;
    var zona = c.querySelector('[data-ccm-sug]'); if (!zona) return;
    var car = c.querySelector('[data-ccm-car]');
    var cards = zona.children, total = cards.length, i;
    if (!total) {
      // Sin sugerencias no hay carrusel NI zona: la caja se pinta con texto y barra, y
      // nada más. Un hueco vacío entre la barra y el borde se lee como algo roto.
      zona.hidden = true;
      if (car) car.hidden = true;
      return;
    }
    // Vuelta en los dos sentidos: desde la 1ª, `‹` lleva a la ÚLTIMA. El módulo se
    // escribe así (y no `n % total`) porque en JS el resto de un negativo es negativo.
    iSug = ((n % total) + total) % total;
    for (i = 0; i < total; i++) cards[i].hidden = (i !== iSug);
    // Con UNA sola sugerencia las flechas no se pintan: dos botones que no llevan a
    // ninguna parte son ruido, y a 375 px se comen 100 px de ancho de la tarjeta.
    var navs = c.querySelectorAll('[data-ccm-prev],[data-ccm-next]');
    for (i = 0; i < navs.length; i++) navs[i].hidden = (total <= 1);
    zona.hidden = false;
    if (car) car.hidden = false;
  }

  // `modo`/`pctReal` sólo se usan para calcular el precio tachado de cada tarjeta
  // (`precioTarjeta`); son opcionales y, sin ellos, cada tarjeta cae al precio de lista
  // simple (mismo comportamiento que antes del 11-sep).
  function pintarSugerencias(sug, etq, modo, pctReal, puro2x1) {
    var c = laCaja(); if (!c) return;
    var zona = c.querySelector('[data-ccm-sug]'); if (!zona) return;
    while (zona.firstChild) zona.removeChild(zona.firstChild);
    // 🔒 «AL LLEGAR A TU META» ES SUTIL Y ÚNICA (dueño §7): una nota por TARJETA
    //    saturaría una barra que el dueño pidió compacta; se dice UNA vez, bajo el
    //    carrusel, y sólo cuando de verdad hay algún precio CONDICIONAL a la vista.
    var hayCondicional = false;
    for (var i = 0; i < sug.length; i++) {
      var n = normalizar(sug[i]);
      var pinfo = precioTarjeta(modo, n, pctReal, puro2x1);
      if (pinfo && pinfo.condicional) hayCondicional = true;
      zona.appendChild(tarjeta(n, etq, pinfo));
    }
    var nota = c.querySelector('[data-ccm-nota]');
    if (nota) {
      if (hayCondicional) {
        nota.textContent = 'El precio con -' + PCT_DEF + '% se aplica al llegar a tu meta';
        nota.hidden = false;
      } else {
        nota.hidden = true;
      }
    }
    // El estado visible lo gobierna SIEMPRE el carrusel (incluido el caso de cero
    // tarjetas): un solo sitio que decide qué se ve, o los dos se desincronizan.
    mostrarSug(0);
  }

  function idsDelCarrito(cart) {
    var out = [], it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) out.push(it[i].product_id);
    return out;
  }

  // ── DICTADO DEL DUEÑO 21-sep: EL CARRUSEL SIEMPRE MUESTRA EL 2x1 ──────────────
  // «en la barra de meta, en TODOS los productos, lo que se sugiere ahí abajo debe ser
  // lo del 2x1, como en la colección 2x1; las tarjetas como están, están bien». Hasta
  // hoy sólo el modo B (fichas/carrito con un 2x1 dentro) sugería la colección ✨2x1✨;
  // el modo A (ficha normal) pedía recomendaciones NATIVAS de Shopify. Ahora las DOS
  // rutas parten de la misma lista — la del propio `data-ccm-2x1` que emite el Liquid
  // en TODAS las páginas donde se pinta la barra (fichas normales, las 6 fichas del
  // 2x1 y /cart) — y se pintan con el MISMO diseño de tarjeta de siempre (tachado,
  // «2 por $X», chip «2x1»): la etiqueta y el precio los sigue decidiendo
  // `precioTarjeta`/`etiquetaSug` con `modo:'b'`, el molde que ya existía para el 2x1,
  // así que no se duplica esa lógica.
  // 🔒 FAIL-OPEN, documentado por el propio dueño («si tiene menos de 2 disponibles,
  //    cae a lo que hacía antes»): si tras excluir el producto actual, lo que ya va en
  //    el carrito y el Colibrí quedan MENOS de 2 productos del 2x1, se cae al
  //    comportamiento de siempre — modo A → recomendaciones de Shopify; modo B → lo que
  //    haya (nunca tuvo otra fuente). Nunca deja el carrusel roto por una colección
  //    corta o mal configurada.
  function sugerir(modo, cart) {
    var c = laCaja(); if (!c) return;
    var l2 = lista2x1();
    var handles2x1 = l2.map(function (p) { return String(p.handle || ''); });
    var yaEnCarrito = idsDelCarrito(cart);
    var actual = c.getAttribute('data-ccm-producto');
    if (actual) yaEnCarrito.push(actual);
    var pctReal = porcentajeCarrito(cart);

    var sug2x1 = filtrarSugerencias(l2, {
      handlesFuera: [COLIBRI], idsFuera: yaEnCarrito, max: TOPE_SUG,
    });

    if (sug2x1.length >= 2) {
      // ¿EL CARRITO ES PURO 2x1? (fix 11-sep, hallazgo MEDIO del escéptico, conservado
      // tal cual): si trae algo que NO es de la colección ✨2x1✨, Shopify puede aplicar
      // el -30% de nivel carrito en vez del 2x1 (combinesWith de los dos es `false`:
      // gana uno solo), y «2 por $X» dejaría de ser cierto para esa pieza. Un carrito
      // vacío SÍ es puro: todavía no hay nada que lo contradiga. Esto decide el PRECIO
      // de la tarjeta, no si se muestra: la etiqueta «2x1» se mantiene siempre, igual
      // que ya hacía el modo B.
      var idsSet = {}, k;
      for (k = 0; k < l2.length; k++) idsSet[String(l2[k].id)] = 1;
      var puro = true, itC = (cart && cart.items) || [];
      for (k = 0; k < itC.length; k++) {
        if (!idsSet[String(itC[k] && itC[k].product_id)]) { puro = false; break; }
      }
      pintarSugerencias(sug2x1, '2x1', 'b', pctReal, puro);
      return;
    }

    // Colección 2x1 con menos de 2 disponibles: fail-open al comportamiento anterior.
    var etq = etiquetaSug(modo, cart);
    if (modo === 'b') {
      // Modo B nunca tuvo otra fuente que la propia colección: se pinta lo que haya
      // (0 ó 1 tarjetas), tal como hacía antes del 21-sep.
      pintarSugerencias(sug2x1, '2x1', modo, pctReal, true);
      return;
    }
    // Modo A, fallback: recomendaciones NATIVAS de Shopify (gratis), como hacía antes
    // del 21-sep. Fuera el Colibrí y fuera los del 2x1: bajo un cartel que habla del
    // -30%, ofrecer una pieza que se vende con otra mecánica es prometer un descuento
    // que no le aplica.
    var pid = actual || (cart && cart.items && cart.items[0] && cart.items[0].product_id);
    if (!pid) { pintarSugerencias([], etq, modo, pctReal); return; }
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) +
          '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var ps = (j && j.products) || [];
        pintarSugerencias(filtrarSugerencias(ps, {
          handlesFuera: [COLIBRI].concat(handles2x1), idsFuera: yaEnCarrito, max: TOPE_SUG,
        }), etq, modo, pctReal);
      })
      // Si la recomendación falla, la barra se queda SIN carrusel. Nunca un hueco roto.
      .catch(function () { pintarSugerencias([], etq, modo, pctReal); });
  }

  // ── EL SUBTOTAL NATIVO DE DAWN, RESALTADO (dueño §12, ronda 2, 11-sep) ─────
  // Sólo existe en `/cart` (bloque `subtotal` de `main-cart-footer`, ver
  // `tema-redisenio/templates/cart.json`). Si Dawn cambiara esas clases, esto
  // simplemente no encuentra nada y no toca nada — fail-safe, nunca fail-open.
  function resaltarSubtotalNativo() {
    var etiqueta = document.querySelector('.totals__subtotal');
    var envoltorio = etiqueta ? etiqueta.closest('.totals') : document.querySelector('.totals');
    if (envoltorio) envoltorio.classList.add('ccm-subtotal--resaltado');
  }

  /* 🛒 (26-oct, dueño punto 11) EN LA FICHA, CON EL CARRITO VACÍO, CUENTA EL PAQUETE ELEGIDO.
     El 2x1 se pide por el formulario contra entrega, no por el carrito: la barra decía
     «agrega productos para empezar» con el 2x1 ya marcado. cod-co.js publica el precio
     que ya pintan sus tarjetas (`window.CcoPack` + evento `cco:pack`); aquí sólo se dice:
     «Con tu 2x1 llevas $63.000: te faltan $66.000 para tu envío GRATIS 🍃». Con algo en
     el carrito, manda el carrito (lo de siempre). */
  function packElegido() {
    var p = window.CcoPack;
    if (!p || typeof p !== 'object') return null;
    var precio = Math.round(Number(p.precio));
    if (!(precio > 0)) return null;
    return { cent: precio * 100, es2x1: p.es2x1 === true, unidades: Number(p.unidades) || 1 };
  }
  function textoPack(pk, meta) {
    var m = metaValida(meta);
    var quien = pk.es2x1 ? 'Con tu 2x1' : 'Con lo que elegiste';
    if (pk.cent >= m) return '¡' + quien + ' el envío es GRATIS 🍃!';
    return quien + ' llevas ' + copDeCentavos(pk.cent) + ': te faltan ' + copDeCentavos(m - pk.cent) + ' para tu envío GRATIS 🍃';
  }
  function pctPack(pk, meta) {
    var m = metaValida(meta);
    if (pk.cent >= m) return 100;
    var v = Math.round(100 * pk.cent / m);
    return v > 99 ? 99 : (v < 0 ? 0 : v);
  }
  /* 🛒 (26-oct, dueño punto 11) EL CARRITO VACÍO: sin barra (no hay de qué hablar), «Ver el
     2x1 de hoy» en vez de «Seguir comprando», «está» con tilde y sin el bloque de cuenta.
     Es el HTML de Dawn (main-cart-items): se toca sólo el texto y el enlace, nunca la
     estructura, y si Dawn cambiara sus clases esto no encuentra nada y no toca nada. */
  function arreglarCarritoVacio() {
    try {
      var vacio = document.querySelector('.cart__warnings');
      if (!vacio) return;
      var tit = vacio.querySelector('.cart__empty-text');
      if (tit && /esta vac/i.test(tit.textContent || '')) tit.textContent = String(tit.textContent).replace(/\besta vac/i, 'está vac');
      var bot = vacio.querySelector('a.button');
      if (bot && !bot.hasAttribute('data-ccm-2x1-link')) {
        bot.setAttribute('data-ccm-2x1-link', '1');
        bot.textContent = 'Ver el 2x1 de hoy';
        bot.setAttribute('href', '/collections/' + encodeURIComponent('✨2x1✨'));
      }
      var cuenta = vacio.querySelectorAll('.cart__login-title, .cart__login-paragraph');
      for (var i = 0; i < cuenta.length; i++) cuenta[i].hidden = true;
    } catch (e) { /* el carrito vacío de siempre */ }
  }
  /* 🛒 (26-oct, dueño punto 11) Bajo «Realizar pago», UNA línea con las formas de pago. */
  function lineaFormasDePago() {
    try {
      var ctas = document.querySelector('.cart__ctas');
      if (!ctas || document.querySelector('[data-ccm-pagos]')) return;
      var p = document.createElement('p');
      p.className = 'ccm-pagos';
      p.setAttribute('data-ccm-pagos', '');
      p.textContent = 'Paga con Addi o Wompi, o pídelo y paga al recibir.';
      ctas.parentNode.insertBefore(p, ctas.nextSibling);
    } catch (e) { /* */ }
  }
  var ultimoCart = null;

  function pintar(cart) {
    ultimoCart = cart;
    var c = laCaja(); if (!c) return;
    var meta = umbralDeLaPagina(c);
    var prom = num(c.getAttribute('data-ccm-pct')) || PCT_DEF;
    // El 4º argumento es la palanca del carrito MEZCLADO (§18.3). Vive en el Liquid,
    // no aquí: cambiarlo es editar un atributo, no desplegar un asset.
    var modo = modoEfectivo(c.getAttribute('data-ccm-modo'), cart,
                            lista2x1().map(function (p) { return p.id; }),
                            c.getAttribute('data-ccm-mixto'));
    // Se publica el modo REAL para poder verlo en la vista previa (y en los asserts).
    c.setAttribute('data-ccm-modo-vivo', modo);
    // Y la MARQUESINA se pone en el mismo modo, antes de escribir cualquier texto: las
    // dos cosas que el cliente lee sobre la misma oferta no pueden decir lo contrario.
    // (Medido el 10-sep en el preview: con un carrito 100 % 2x1, la franja prometía el
    // -30% mientras esta barra ya estaba en modo B, sin nombrarlo.)
    sincronizarMarquesina(modo);
    // 🔴 SÓLO EN EL CARRITO (dueño §12, ronda 2, 11-sep): `data-ccm-producto` viaja vacío
    //    ahí (en la ficha trae el id del producto), así que es el mismo DATO que ya
    //    distingue las dos plantillas en meta-co.liquid — no un ajuste nuevo.
    var esCarrito = !c.getAttribute('data-ccm-producto');
    if (esCarrito) {
      lineaFormasDePago();
      arreglarCarritoVacio();   // el bloque vacío de Dawn existe siempre (oculto si hay artículos)
      if (!carritoConArticulos(cart)) { c.hidden = true; return; }
    }
    var pk = (!esCarrito && !carritoConArticulos(cart)) ? packElegido() : null;
    var t = c.querySelector('[data-ccm-t]');
    // 21-oct: en el carrito, la frase del formulario («Te faltan $X para tu envío GRATIS»).
    if (t) t.textContent = pk ? textoPack(pk, meta)
                       : (esCarrito ? textoCarrito(modo, cart, meta, copDeCentavos, prom)
                                    : texto(modo, cart, meta, copDeCentavos, prom));
    var fill = c.querySelector('[data-ccm-fill]');
    if (fill) fill.style.width = (pk ? pctPack(pk, meta) : pct(cart, meta, modo)) + '%';
    var sub = c.querySelector('[data-ccm-sub]');
    if (sub) {
      if (esCarrito) { sub.textContent = textoSubtotalCarrito(modo, cart, meta); sub.hidden = false; }
      else { sub.hidden = true; }
    }
    if (esCarrito) resaltarSubtotalNativo();
    c.hidden = false;
    sugerir(modo, cart);
  }

  var pidiendo = false;
  function refrescar() {
    if (pidiendo || !laCaja()) return;
    pidiendo = true;
    // ⏱️ (21-oct-2026) Con tiempo límite: un /cart.js colgado dejaba `pidiendo` en true
    // PARA SIEMPRE y la barra no volvía a refrescarse en toda la visita. Al vencer se
    // aborta y se suelta el candado (la caja se queda como estaba, igual que en un fallo).
    var ctrl = null;
    try { ctrl = (typeof AbortController === 'function') ? new AbortController() : null; } catch (e) { ctrl = null; }
    var suelto = false;
    var soltar = function () { if (suelto) return; suelto = true; pidiendo = false; };
    var tope = setTimeout(function () { try { if (ctrl) ctrl.abort(); } catch (e) { /* */ } soltar(); }, 10000);
    var init = { headers: { Accept: 'application/json' } };
    if (ctrl) init.signal = ctrl.signal;
    fetch('/cart.js', init)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart && !suelto) pintar(cart); })
      .catch(function () { /* sin carrito no se pinta nada: la caja sigue oculta */ })
      .then(function () { clearTimeout(tope); soltar(); });
  }

  var pend = null;
  function refrescarPronto() {
    if (pend) clearTimeout(pend);
    // Se agrupan las ráfagas del carrito de Dawn (un cambio de cantidad repinta varias
    // veces): una sola lectura de /cart.js por ráfaga.
    pend = setTimeout(function () { pend = null; refrescar(); }, 250);
  }

  function arrancar() {
    if (!laCaja()) return;
    refrescar();
    // El corte del -30% puede llegar mientras el cliente sigue en la página sin tocar
    // el carrito: `refrescarPronto()` vuelve a leer /cart.js y re-pinta todo (barra de
    // meta, sugerencias, marquesina) con `promoVigente()` ya en `false` — mismo camino
    // que cualquier otro refresco, ningún atajo nuevo.
    programarRecorte(refrescarPronto);
    // ── LAS FLECHAS ─────────────────────────────────────────────────────────
    // UN solo oyente, colgado por DELEGACIÓN y una sola vez. Los botones se crean y se
    // ocultan en cada pintado, así que colgarles un oyente a cada uno los acumularía
    // en cada refresco del carrito.
    // Va en `document` y no en la caja a propósito: en el carrito, el tema re-renderiza
    // trozos de la página por AJAX, y si algún día la caja se reemplazara, un oyente
    // pegado a ELLA se iría con el nodo viejo y las flechas dejarían de responder sin
    // que nada se pusiera rojo. El `closest` lo mantiene acotado a nuestra caja.
    // 🔒 Cero peticiones: mover el carrusel es puro DOM (lo mide un assert que cuenta
    //    las llamadas a /cart.js antes y después de pulsar).
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!t.closest('[data-ccm]')) return;
      if (t.closest('[data-ccm-prev]')) { e.preventDefault(); mostrarSug(iSug - 1); return; }
      if (t.closest('[data-ccm-next]')) { e.preventDefault(); mostrarSug(iSug + 1); }
    });
    // El carrito de Dawn cambia por AJAX y sin recargar. Tres señales, ningún temporizador:
    //  · `cart:refresh` / `cart:update`, que publican el tema y varias apps;
    //  · el <cart-items> de la página del carrito, que se re-renderiza al cambiar cantidades;
    //  · la burbuja del contador de la cabecera, que se actualiza al agregar desde CUALQUIER
    //    página (es la única señal que llega en la ficha).
    document.addEventListener('cart:refresh', refrescarPronto);
    document.addEventListener('cart:update', refrescarPronto);
    // 🛒 (26-oct) El paquete elegido cambió en el formulario: se repinta con el último
    // carrito leído, SIN otra petición a /cart.js.
    document.addEventListener('cco:pack', function () { if (ultimoCart) pintar(ultimoCart); });
    // 🐛 `pageshow` SÓLO CUANDO LA PÁGINA VUELVE DE LA CACHÉ ATRÁS/ADELANTE (`persisted`).
    //    Sin ese filtro se dispara TAMBIÉN en cada carga normal, justo después del
    //    `refrescar()` de arriba: dos lecturas de /cart.js por visita, una inútil. Lo cazó
    //    el assert que cuenta las peticiones, no una revisión a ojo.
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) refrescarPronto(); });
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(refrescarPronto);
      var vigilar = function (sel) {
        var n = document.querySelector(sel);
        if (n) obs.observe(n, { childList: true, subtree: true, characterData: true });
      };
      vigilar('cart-items');
      vigilar('.cart-count-bubble');
      vigilar('#cart-icon-bubble');
    }
  }

  function arrancarTodo() {
    arrancar();
    // Independiente de `arrancar()`: corre en TODAS las páginas (home, colecciones,
    // fichas 2x1) tengan o no barra de meta, y se auto-descarta si `laCaja()` existe
    // (ahí ya manda `pintar()`).
    arrancarMarquesinaSola();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancarTodo);
  else arrancarTodo();
})();
